import React, { useState } from 'react';
import PropTypes from 'prop-types';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import packageJson from './../../../../package.json'
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import SettingsOutlined from '@ant-design/icons/SettingOutlined';
import ViewProfilePage from './viewProfilePage';

interface ProfileTabProps {
  handleLogout: () => void;
}

const ProfileTab: React.FC<ProfileTabProps> = ({ handleLogout }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const navigate = useNavigate();

  const signOut = (): void => {
    localStorage.clear();
    handleClose();
    navigate('/');
  };

  const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
    setSelectedIndex(index);
    if (index === 1) {
      setOpenDialog(true);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };


  return (
    <>
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)}>
          <ListItemIcon>
            <UserOutlined />
          </ListItemIcon>
          <ListItemText primary="About Huewine" />
        </ListItemButton>

        {/* New Settings Item */}
        <ListItemButton selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)}>
          <ListItemIcon>
            <SettingsOutlined />
          </ListItemIcon>
          <ListItemText primary="Settings" />
        </ListItemButton>

        <ListItemButton selected={selectedIndex === 2} onClick={signOut}>
          <ListItemIcon>
            <LogoutOutlined />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>

      <Box sx={{ padding: 2, textAlign: 'center', fontSize: '14px', color: 'gray' }}>
        <Typography variant="body2">Version: {packageJson.version}</Typography>
      </Box>

      <Dialog fullScreen open={openDialog} onClose={handleClose}>
        <ViewProfilePage handleClose={handleClose} />
      </Dialog>
    </>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func.isRequired,
};

export default ProfileTab;






